export interface TeamFollowupTask {
  id: string;
  title: string;
  dueDate: string;
  status: 'todo' | 'done';
  priority: 'low' | 'normal' | 'high';
  notes: string;
  createdAt: string;
  completedAt: string;
}

export interface TeamSubscriptionRecord {
  subscriptionId: string;
  ownerName: string;
  ownerEmail: string;
  updatedAt: string;
  tasks: TeamFollowupTask[];
}

const ENDPOINT = '/api/admin/team-workspace';

const parseResponse = async <T,>(response: Response): Promise<T> => {
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.error || payload?.message || 'Erreur espace equipe');
  }
  return payload as T;
};

export const adminTeamWorkspaceService = {
  async getRecords(): Promise<TeamSubscriptionRecord[]> {
    const response = await fetch(ENDPOINT, {
      credentials: 'include',
      cache: 'no-store',
    });
    const payload = await parseResponse<{ records?: TeamSubscriptionRecord[] }>(response);
    return Array.isArray(payload.records) ? payload.records : [];
  },
  async saveRecords(records: TeamSubscriptionRecord[]): Promise<TeamSubscriptionRecord[]> {
    const response = await fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ records }),
    });
    const payload = await parseResponse<{ records?: TeamSubscriptionRecord[] }>(response);
    return Array.isArray(payload.records) ? payload.records : [];
  },
};
